module.exports = __webpack_public_path__ + "web_static/img/about_hkstp.5ae1dc40.png";